import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, resolveComponent as _resolveComponent, createVNode as _createVNode, toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, isRef as _isRef, createTextVNode as _createTextVNode, withCtx as _withCtx, openBlock as _openBlock, createBlock as _createBlock } from "vue"
import _imports_0 from '@/assets/images/logo-color.svg'


const _hoisted_1 = { class: "text-h5 text-center mb-4" }
const _hoisted_2 = { class: "d-flex hover py-2 justify-space-between align-center" }
const _hoisted_3 = { class: "text-primary font-weight-medium" }
const _hoisted_4 = { class: "text-subtitle-2" }
const _hoisted_5 = { class: "d-flex py-2 justify-space-between align-center" }
const _hoisted_6 = { class: "bg-hightlight font-weight-medium" }
const _hoisted_7 = { class: "text-subtitle-2" }

import { useUpdateUser } from '@/composables/user';
import { RoutesNames } from '@/router/routesNames';
import { useUserStore } from '@/store/user';
import { useRouter } from 'vue-router';
import { OnBoardingUser, UserType } from '@/graphql/types/graphql';
import { useDialogsStore } from '@/store/dialogs';
import { ref } from 'vue';
import { useOnboardingStore } from '@/store/onboarding';


export default /*#__PURE__*/_defineComponent({
  __name: 'WhoAreYouDialog',
  setup(__props) {

let router = useRouter();
let onboardingStore = useOnboardingStore();
let dialogsStore = useDialogsStore();
let userStore = useUserStore();

let talent = ref(false);
let user = ref(false);

const {
    mutate: updateUser,
    loading: loadingUpdate,
    onDone: onDoneUpdate,
} = useUpdateUser();

onDoneUpdate((result) => {
    dialogsStore.whoAreYou = false;
});

async function handleContinue() {
    let userType = UserType.Talent;
    if (user.value) {
        userType = UserType.User;
    }
    //Prossimo step dopo la scelta del tipo utente è Name per mantenere congruità con l'applicazione
    await updateUser({
        id: userStore.getUserId,
        onboarding_user_step: OnBoardingUser.Name,
        userType: userType,
    });
}

return (_ctx: any,_cache: any) => {
  const _component_v_img = _resolveComponent("v-img")!
  const _component_v_switch = _resolveComponent("v-switch")!
  const _component_v_divider = _resolveComponent("v-divider")!
  const _component_v_btn = _resolveComponent("v-btn")!
  const _component_v_col = _resolveComponent("v-col")!
  const _component_v_row = _resolveComponent("v-row")!
  const _component_v_sheet = _resolveComponent("v-sheet")!
  const _component_v_dialog = _resolveComponent("v-dialog")!

  return (_openBlock(), _createBlock(_component_v_dialog, {
    class: "font",
    modelValue: _unref(dialogsStore).whoAreYou,
    "onUpdate:modelValue": _cache[4] || (_cache[4] = ($event: any) => ((_unref(dialogsStore).whoAreYou) = $event)),
    persistent: ""
  }, {
    default: _withCtx(() => [
      _createVNode(_component_v_sheet, {
        width: "400",
        class: "pa-6 rounded-xl"
      }, {
        default: _withCtx(() => [
          _createVNode(_component_v_row, {
            "no-gutters": "",
            class: "d-flex justify-center"
          }, {
            default: _withCtx(() => [
              _createVNode(_component_v_col, { class: "px-2" }, {
                default: _withCtx(() => [
                  _createVNode(_component_v_img, {
                    height: "70",
                    width: "70",
                    class: "mx-auto mb-6",
                    src: _imports_0
                  }),
                  _createElementVNode("div", _hoisted_1, _toDisplayString(_ctx.$t('who_are_you')), 1),
                  _createElementVNode("div", _hoisted_2, [
                    _createElementVNode("div", null, [
                      _createElementVNode("div", _hoisted_3, _toDisplayString(_ctx.$t('i_am_talent')), 1),
                      _createElementVNode("div", _hoisted_4, _toDisplayString(_ctx.$t('and_i_search_job')), 1)
                    ]),
                    _createElementVNode("div", null, [
                      _createVNode(_component_v_switch, {
                        modelValue: _unref(talent),
                        "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => (_isRef(talent) ? (talent).value = $event : talent = $event)),
                        onChange: _cache[1] || (_cache[1] = ($event: any) => (_isRef(user) //@ts-ignore
 ? user.value = !_unref(talent) : user = !_unref(talent))),
                        color: "primary"
                      }, null, 8, ["modelValue"])
                    ])
                  ]),
                  _createVNode(_component_v_divider),
                  _createElementVNode("div", _hoisted_5, [
                    _createElementVNode("div", null, [
                      _createElementVNode("div", _hoisted_6, _toDisplayString(_ctx.$t('i_am_company')), 1),
                      _createElementVNode("div", _hoisted_7, _toDisplayString(_ctx.$t('and_i_search_talents')), 1)
                    ]),
                    _createElementVNode("div", null, [
                      _createVNode(_component_v_switch, {
                        modelValue: _unref(user),
                        "onUpdate:modelValue": _cache[2] || (_cache[2] = ($event: any) => (_isRef(user) ? (user).value = $event : user = $event)),
                        onChange: _cache[3] || (_cache[3] = ($event: any) => (_isRef(talent) //@ts-ignore
 ? talent.value = !_unref(user) : talent = !_unref(user))),
                        color: "secondary"
                      }, null, 8, ["modelValue"])
                    ])
                  ]),
                  _createVNode(_component_v_btn, {
                    rounded: "pill",
                    class: "text-uppercase mt-10",
                    color: "primary",
                    flat: "",
                    block: "",
                    loading: _unref(loadingUpdate),
                    onClick: handleContinue,
                    disabled: !_unref(user) && !_unref(talent)
                  }, {
                    default: _withCtx(() => [
                      _createTextVNode(_toDisplayString(_ctx.$t('continue')), 1)
                    ]),
                    _: 1
                  }, 8, ["loading", "disabled"])
                ]),
                _: 1
              })
            ]),
            _: 1
          })
        ]),
        _: 1
      })
    ]),
    _: 1
  }, 8, ["modelValue"]))
}
}

})